<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel v-for="(item, i) in items" :key="i">
      <v-expansion-panel-header class="header title grey lighten-3 secondary--text">
        <div><v-icon color="secondary">mdi-google-classroom</v-icon>&nbsp; {{ item.nama }}</div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <m-card-list
          :add="isCan('enrol')"
          :deleteData="isCan('enrol')"
          :addDisable="item.grup.length >= $consts.BATAS_GROUP"
          addText="Kelompok"
          title="Daftar Kelompok"
          id-key
          filter
          :items="item.grup"
          footerLabel="Kelas"
          @add="add(item)"
          @delete="hapusKelompok(item)"
          footer
        >
          <template v-slot:filter
            ><m-alert
              show
              type="info"
              info="Jumlah Maksimal Kelompok dalam 1 Kelas adalah 2 Kelompok (2 Grup)"
            ></m-alert
          ></template>
          <template v-slot:items="{ item }">
            <v-row :class="$vuetify.breakpoint.smAndDown ? 'my-0 py-0' : 'mx-3 my-0 py-0'">
              <v-col class="my-0 py-0" cols="3" sm="1" md="1" lg="1" align="center">
                <v-avatar width="50" height="50" :size="45" color="secondary2">
                  <v-icon color="secondary">mdi-google-classroom</v-icon>
                </v-avatar>
              </v-col>
              <v-col class="my-0 py-0" cols="12" sm="12" md="10" lg="10">
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                    <v-list class="py-0">
                      <v-list-item class="grey--text" @click="detil(item)">
                        <v-list-item-content class="pb-1" style="white-space: normal;">
                          <span class="caption grey--text">Nama</span>
                          <p class=" primary--text  my-0 font-weight-bold">{{ pVal(item, "nama") }}</p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                    <!-- <p class="caption my-0 pt-3 grey--text align-left">
                        Peserta
                      </p>
                      <span class="my-0">{{ item.count_peserta }}</span> -->
                    <v-list class="py-0">
                      <v-list-item class="grey--text">
                        <v-list-item-content>
                          <span class="caption grey--text">Peserta</span>
                          <p class="title primary--text">{{ item.peserta_count }}</p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                    <v-list class="py-0">
                      <v-list-item class="grey--text">
                        <v-list-item-content>
                          <span class="caption grey--text">Fasilitator</span>
                          <p class="title primary--text">{{ item.fasilitator_count }}</p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                    <v-list class="py-0">
                      <v-list-item class="grey--text">
                        <v-list-item-content>
                          <span class="caption grey--text">Pendamping</span>
                          <p class="title primary--text">{{ item.pendamping_count }}</p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-col>

              <v-col lg="1" md="1" sm="1" cols="1">
                <m-menu right class="clearfix" style="float: right" :items="more_menu" :object="item" />
              </v-col>
            </v-row>
            <v-divider />
          </template>
        </m-card-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <ChangeDlg ref="dlgGroup" />
    <ChangeDetailDlg ref="dlgDetailGroup" @load="load" />
  </v-expansion-panels>
</template>

<script>
import ChangeDlg from "../../kelas/components/FormGroup.vue";
import ChangeDetailDlg from "../../kelas/components/DetailGroup.vue";
export default {
  components: {
    ChangeDlg,
    ChangeDetailDlg
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      panel: null,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Detail",
          icon: "mdi-eye",
          color: "info",
          click: (i, o) => this.detil(o)
        },
        // {
        //   title: "Ubah",
        //   click: (i, o) => this.edit(o)
        // }
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o)
        }
      ],
      page: null,
      cp: 1
    };
  },
  computed: {},
  methods: {
    add(grouping) {
      this.$refs.dlgGroup.open(null, grouping).then(() => {
        this.load();
      });
    },
    edit(obj) {
      this.$refs.dlgGroup.open(obj).then(() => {
        this.$emit("load");
      });
    },
    detil(grup) {
      this.$refs.dlgDetailGroup.open(grup).then(() => {
        this.$emit("load");
      });
    },
    load() {
      this.$emit("load");
    },
    hapusKelompok(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus Pengelompokan ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() =>
          this.$store.dispatch("kelas/dropGrouping", {
            instansi_id: item.instansi_id,
            diklat_id: item.diklat_id,
            kelas_id: item.kelas_id,
            kelas_modul_id: item.kelas_modul_id,
            grouping_id: item.id
          })
        )
        .then(res => {
          if (res.status == 201) {
            this.$info("Hapus data Pengelompokan berhasil");
          }
        })
        .then(() => this.load())
        .catch(e => e);
    },
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus kelompok ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() =>
          this.$store.dispatch("kelas/dropGroup", {
            instansi_id: item.instansi_id,
            diklat_id: item.diklat_id,
            kelas_id: item.kelas_id,
            kelas_modul_id: item.kelas_modul_id,
            grouping_id: item.kelas_gruping_id,
            obj: item
          })
        )
        .then(res => {
          if (res.status == 201) {
            this.$info("Hapus data Kelompok berhasil");
          }
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
